import { Last7DaysRange } from '@seller-hermes/features/ui-v2/DateRangePicker';
import { Action, action } from 'easy-peasy';
import { DateRange } from 'react-day-picker';

export interface DeliveryFiltersStoreModel {
  selectedCarrierMethodGroups: string[];
  setSelectedCarrierMethodGroups: Action<DeliveryFiltersStoreModel, string[]>;
  selectedSellers: string[];
  setSelectedSellers: Action<DeliveryFiltersStoreModel, string[]>;
  selectedDateRange?: DateRange;
  setSelectedDateRange: Action<
    DeliveryFiltersStoreModel,
    DateRange | undefined
  >;
}

const deliveryFiltersStoreModel: DeliveryFiltersStoreModel = {
  selectedCarrierMethodGroups: [],
  setSelectedCarrierMethodGroups: action((state, payload) => {
    state.selectedCarrierMethodGroups = payload;
  }),
  selectedSellers: [],
  setSelectedSellers: action((state, payload) => {
    state.selectedSellers = payload;
  }),
  selectedDateRange: Last7DaysRange.range(),
  setSelectedDateRange: action((state, payload) => {
    state.selectedDateRange = payload;
  }),
};

export default deliveryFiltersStoreModel;
